import zoid from 'zoid';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
const BASE_URL = 'https://preview.widgets.ninetailed.io/v2';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let bridge;
const PreviewBridge = ({
  url: _url = BASE_URL,
  nonce
}) => {
  if (!bridge) {
    bridge = zoid.create({
      tag: 'ninetailed-preview',
      url: _url,
      dimensions: {
        width: `432px`,
        height: `100vh`
      }
    });
  }
  return bridge({
    cspNonce: nonce
  });
};

export { PreviewBridge };
